import React from "react";

import data from "currency-codes/data";

import { SelectInput, TextInput } from "../../../../forms/components";

const GatewayIdentificationForm = (props) => {
	const { addMID, gateway, gatewayId, midCount, codes } = props;
	return (
		<div className="uk-margin-medium-bottom">
			<h5>
				<img
					className="uk-img uk-margin-right"
					src={`data:image/*;base64,${gateway.image}`}
					width="50"
				/>
				<button
					className="uk-margin-small-left uk-icon-button uk-button-primary"
					uk-icon="icon: fa-solid-plus-circle; ratio: 0.5"
					type="button"
					onClick={() => addMID(gatewayId)}
				/>
				{gateway.name === "2C2P" && (
					<div
						className="uk-margin-left uk-width-1-4@s"
						style={{
							display: "flex",
							alignItems: "center",
							float: "right",
						}}
					>
						<label className="uk-form-label uk-margin-right">Version</label>
						<select className="uk-select" name="tctpVersion" id="tctpVersion">
							<option key={4} value={4} className="uk-text-capitalize">
								4
							</option>
							<option
								selected="selected"
								key={3}
								value={3}
								className="uk-text-capitalize"
							>
								3
							</option>
						</select>
					</div>
				)}
				{gateway.name === "UQPAY" && (
					<div
						className="uk-margin-left uk-width-1-4@s"
						style={{
							display: "flex",
							alignItems: "center",
							float: "right",
						}}
					>
						<label className="uk-form-label uk-margin-right">Version</label>
						<select className="uk-select" name="uqpayVersion" id="uqpayVersion">
							<option key={2} value={2} className="uk-text-capitalize">
								2
							</option>
							<option
								selected="selected"
								key={1}
								value={1}
								className="uk-text-capitalize"
							>
								1
							</option>
						</select>
					</div>
				)}
			</h5>
			{[...Array(midCount)].map((e, i) => {
				return (
					<div
						key={i}
						className="uk-grid-column-small uk-grid-row-medium uk-grid"
					>
						<div className="uk-width-1-4">
							<SelectInput
								label="Currency"
								data={codes}
								id={`${gatewayId}.code.${i}`}
								name={`${gatewayId}.code.${i}`}
								initialEmpty={true}
							/>
						</div>
						<div className="uk-width-3-4">
							<TextInput
								label="Merchant Identification"
								id={`${gatewayId}.mid.${i}`}
								name={`${gatewayId}.mid.${i}`}
								type="text"
							/>
						</div>
						{gateway.name === "UQPAY" && (
							<>
								<div className="uk-width-3-4">
									<TextInput
										label="Transaction Sign ID"
										id={`${gatewayId}.uqpayTransactionSignId.${i}`}
										name={`${gatewayId}.uqpayTransactionSignId.${i}`}
										type="text"
									/>
								</div>
								<div className="uk-width-3-4">
									<TextInput
										label="Transaction Sign Key"
										id={`${gatewayId}.uqpayTransactionSignKey.${i}`}
										name={`${gatewayId}.uqpayTransactionSignKey.${i}`}
										type="text"
									/>
								</div>
								<div className="uk-width-3-4">
									<TextInput
										label="Notification Sign ID"
										id={`${gatewayId}.uqpayNotificationSignId.${i}`}
										name={`${gatewayId}.uqpayNotificationSignId.${i}`}
										type="text"
									/>
								</div>
								<div className="uk-width-3-4">
									<TextInput
										label="Notification Sign Key"
										id={`${gatewayId}.uqpayNotificationSignKey.${i}`}
										name={`${gatewayId}.uqpayNotificationSignKey.${i}`}
										type="text"
									/>
								</div>
							</>
						)}

						{gateway.name === "iPay88" && (
							<>
								<div className="uk-width-1-1">
									<TextInput
										label="iPay88 Merchant Key"
										id={`ipay88MerchantKey`}
										name={`ipay88MerchantKey`}
										type="text"
									/>
								</div>
							</>
						)}
						{gateway.name === "2C2P" && (
							<>
								<div className="uk-width-1-1">
									<TextInput
										label="Current Merchant Authentication Key: (Secret Key)"
										id={`${gatewayId}.authKey.${i}`}
										name={`${gatewayId}.authKey.${i}`}
										type="text"
									/>
								</div>
								<div className="uk-width-1-1">
									<TextInput
										label="Current Merchant SHA Key: (Secret Key)"
										id={`${gatewayId}.shaKey.${i}`}
										name={`${gatewayId}.shaKey.${i}`}
										type="text"
									/>
								</div>
							</>
						)}
						{gateway.name === "RMS" && (
							<>
								<div className="uk-width-1-1">
									<TextInput
										label="Current Merchant Verify Key: (Secret Key)"
										id={`${gatewayId}.verifyKey.${i}`}
										name={`${gatewayId}.verifyKey.${i}`}
										type="text"
									/>
								</div>
								<div className="uk-width-1-1">
									<TextInput
										label="Current Merchant Secret Key: (Secret Key)"
										id={`${gatewayId}.secretKey.${i}`}
										name={`${gatewayId}.secretKey.${i}`}
										type="text"
									/>
								</div>
								<div className="uk-width-1-1">
									<TextInput
										label="Application Code"
										id={`${gatewayId}.rmsApplicationCode.${i}`}
										name={`${gatewayId}.rmsApplicationCode.${i}`}
										type="text"
									/>
								</div>
								<div className="uk-width-1-1">
									<TextInput
										label="Store ID"
										id={`${gatewayId}.rmsStoreId.${i}`}
										name={`${gatewayId}.rmsStoreId.${i}`}
										type="text"
									/>
								</div>
							</>
						)}
						{gateway.name === "Netzme" && (
							<>
								<div className="uk-width-1-1">
									<TextInput
										label="Netzme Client ID"
										id={`${gatewayId}.netzme_clientId.${i}`}
										name={`${gatewayId}.netzme_clientId.${i}`}
										type="text"
									/>
								</div>
								<div className="uk-width-1-1">
									<TextInput
										label="Netzme Client Secret"
										id={`${gatewayId}.netzme_clientSecret.${i}`}
										name={`${gatewayId}.netzme_clientSecret.${i}`}
										type="text"
									/>
								</div>
								<div className="uk-width-1-1">
									<TextInput
										label="Netzme Private Key"
										id={`${gatewayId}.netzme_privateKey.${i}`}
										name={`${gatewayId}.netzme_privateKey.${i}`}
										type="text"
									/>
								</div>
							</>
						)}
					</div>
				);
			})}
		</div>
	);
};
class CreateMerchantIdentification extends React.Component {
	constructor(props) {
		super(props);

		const priorityCode = ["SGD", "MYR", "USD"];
		const codes = [
			...data.filter((i) => priorityCode.includes(i.code)),
			...data.filter((i) => !priorityCode.includes(i.code)),
		];

		this.state = {
			currency: [
				...codes.map((d) => {
					return { name: d.code, value: d.number };
				}),
			],
			MIDCount: Object.keys(props.gateway).reduce((a, c) => {
				a[c] = 0;
				return a;
			}, {}),
		};
	}

	_addMID = (type) => {
		let midCount = this.state.MIDCount;
		if (type !== "ipay88" || (type === "ipay88" && midCount[type] <= 0)) {
			midCount[type]++;
			this.props.newMID(type, midCount[type]);
			this.setState({ MIDCount: midCount });
		}
	};

	render() {
		const { gateway } = this.props;
		return (
			<div className="uk-margin-medium-bottom">
				<h4>
					<span className="uk-flex uk-flex-middle">
						<i
							className="uk-margin-small-right form-header-icon"
							uk-icon="icon: fa-solid-fingerprint; ratio: 0.9"
						/>
						Identification
					</span>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</h4>
				<div className="uk-padding-small uk-padding-remove-vertical">
					{Object.keys(gateway).map((g) => (
						<GatewayIdentificationForm
							key={g}
							gatewayId={g}
							gateway={gateway[g]}
							codes={this.state.currency}
							midCount={this.state.MIDCount[g]}
							addMID={this._addMID}
						/>
					))}
				</div>
			</div>
		);
	}
}

export default CreateMerchantIdentification;
